import React from "react";
import NewsStoriesSection from "../Home/NewsStoriesSection.jsx";

const NewsPage = () => <NewsStoriesSection />;

export default NewsPage;
